<div class="pb-5 fade relative">
  <form [formGroup]="addressform">
    <div class="inline-text-field-container flex-row gap-20">
      <div class="ds-text-field">
        <input class="ds-text-field__input" id="address" type="text" formControlName="address" autocomplete="off" value="{{selectedaddress.addressI}}" required="" [(ngModel)]="selectedaddress.addressI">
        <label for="address" class="ds-floating-label ">*Address</label>
        <div class="field-line-ripple blue"></div>
        @if (addressform.get('address').invalid && addressform.get('address').errors && (addressform.get('address').dirty || addressform.get('address').touched)) {
          <div>
            @if (addressform.get('address').hasError('required')) {
              <span id="add1-errmsg" class="error errmsg">Enter Address</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="inline-text-field-container even-cols flex-row gap-20">
      <div class="ds-text-field">
        <input class="ds-text-field__input" id="city" type="text" formControlName="city" autocomplete="off" value="{{selectedaddress?.city}}" required="" [(ngModel)]="selectedaddress.city">
        <label for="city" class="ds-floating-label ">*City</label>
        <div class="field-line-ripple blue"></div>
        @if (addressform.get('city').invalid && addressform.get('city').errors && (addressform.get('city').dirty || addressform.get('city').touched)) {
          <div>
            @if (addressform.get('city').hasError('required')) {
              <span id="city-errmsg" class="error errmsg">Enter City</span>
            }
          </div>
        }
      </div>
      <div class="ds-text-field inline-text-field-container">
        <div class="select-container chevron border-bottom border-gray-600">
          <select class="ds-select-field rounded-4 hover-gray-300" required="" [(ngModel)]="selectedaddress.stateKey" formControlName="state" (change)='onStateSelected($event)'>
            <option value="" disabled="" selected=""></option>
            <!--<option value="1">None</option>-->
            @for (st of stateslist(); track st) {
              <option
                value="{{ st.key }}">
                {{ st.name }}
              </option>
            }
          </select>
          <label class="ds-floating-label">*State</label>
        </div>
        @if (addressform.get('state').invalid && addressform.get('state').errors && (addressform.get('state').dirty || addressform.get('state').touched)) {
          <div>
            @if (addressform.get('state').hasError('required')) {
              <span id="state-errmsg" class="error errmsg">Select State</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="inline-text-field-container flex-row gap-20">
      <div class="ds-text-field">
        <input class="ds-text-field__input" id="zipcode" type="text" formControlName="zipcode" autocomplete="off" value="{{selectedaddress?.zipCode}}" [(ngModel)]="selectedaddress.zipCode"
          required=""  maxlength="5">
          <label for="address" class="ds-floating-label ">*Zip Code</label>
          <div class="field-line-ripple blue"></div>
          @if (addressform.get('zipcode').invalid && addressform.get('zipcode').errors && (addressform.get('zipcode').dirty || addressform.get('zipcode').touched)) {
            <div>
              @if (addressform.get('zipcode').hasError('required')) {
                <span id="zipcode-errmsg" class="error errmsg">Enter Zip Code</span>
              }
              @if (addressform.get('zipcode').hasError('pattern')) {
                <span id="zippattern-errmsg" class="error errmsg">Enter a valid Zip Code</span>
              }
            </div>
          }
        </div>

        <div class="ds-text-field">
          <input class="ds-text-field__input" id="zipCode4" type="text" formControlName="zipCode4" autocomplete="off" value="{{selectedaddress?.zipCode4}}" [(ngModel)]="selectedaddress.zipCode4"  maxlength="4">
          <label for="address2" class="ds-floating-label">Zip 4</label>
          <div class="field-line-ripple blue"></div>
          @if (addressform.get('zipCode4').invalid && addressform.get('zipCode4').errors && (addressform.get('zipCode4').dirty || addressform.get('zipCode4').touched)) {
            <div>
              @if (addressform.get('zipCode4').hasError('pattern')) {
                <span id="zip4pattern-errmsg" class="error errmsg">Enter a valid Zip Code4</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="container flex gap-20 justify-end">
        <button (click)="cancel()" id="" title="Cancel"
          class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
          <div class="btn-txt font-red bold">Cancel</div>
        </button>
        <button title="Update Address" (click)="update()" class="rounded-full hover-blue-800 black" [disabled]="!addressform.valid">
          <div class="btn-txt font-white">Update Address</div>
        </button>
      </div>
    </form>
  </div>
